import { getProductJson, getSelectedVariantByIdJson, getVariantsByColor } from './helpers';
import { getSizedImageURL } from '../../core/images';

const DEFAULT_IMAGE_WIDTH = 840;
const DEFAULT_IMAGE_HEIGHT = 1344;

// Info displayed on top of the 1st and 2nd images (V4 only)
const generateMainInfoElement = (image_pos) => {
  const pdp_version = (document.querySelector('.template-product-new')) ? 4 : 3;
  if ((image_pos !== 1 && image_pos !== 2) || pdp_version !== 4) {
    return '';
  }

  // const is_plus_size = document.querySelectorAll('[data-product-option-fits] [data-fit-handle="plus"].active').length > 0;
  const fit_option_el = document.querySelector('[data-option-fit]');
  const is_fit_option_visible = fit_option_el && window.getComputedStyle(fit_option_el).display !== 'none';
  const is_plus_size_available = is_fit_option_visible && document.querySelectorAll('[data-product-option-fits] [data-fit-handle="plus"]').length > 0 && document.querySelectorAll('[data-product-option-fits] [data-fit-handle="plus"].active').length === 0;

  return `
    <div class="product-main__info product-main-info">
      ${is_plus_size_available ? `<div class="product-main-info__item">Plus Sizes</div>` : ''}
      <div class="product-main-info__item product-main-info__item--model visually-hidden">
        <span class="product-main-info__text">Model is <span data-extra-sizefit-height></span></span>
        <span class="product-main-info__text">wearing size <span data-extra-sizefit-size></span></span>
      </div>
    </div>
  `;
};

const generateImageElement = (image, size, size_zoom = 'master', lazyload = false, zoom = false, zoom_modal = false, responsive = false, image_pos = 1) => {
  const image_src = image.src;
  const intrinsicWidth = Number(image?.width) > 0 ? Number(image.width) : DEFAULT_IMAGE_WIDTH;
  const intrinsicHeight = Number(image?.height) > 0 ? Number(image.height) : DEFAULT_IMAGE_HEIGHT;
  const img_sized = getSizedImageURL(image_src, size);
  const src_html = (lazyload) ? `loading="lazy" src="${img_sized}"` : `src="${img_sized}"`;
  const zoom_html = (zoom) ? `data-zoom="${getSizedImageURL(image_src, size_zoom)}"` : '';
  const zoom_in_modal = (zoom_modal) ? 'data-modal="#zoom-modal"' : '';
  const product_title = document.querySelector('.product-details__title');
  const title_text = product_title ? product_title.textContent : '';
  const img_alt = (image.alt === null || image.alt === '') ? title_text : image.alt;
  // const isMobile = window.theme.breakpoints.current === 'mobile';
  const pdp_version = (document.querySelector('.template-product-new')) ? 4 : 3;
  const thumb_html = (zoom_modal && pdp_version === 4) ? `data-thumb="${getSizedImageURL(image_src, '180x')}"` : '';

  /*
  // Pull the images from the media array to get the alt defined in the admin
  const product_json = getProductJson();
  if (product_json.media.length) {
    const matching_media = _.find(product_json.media, { src: `https:${image_src}` });
    if (typeof matching_media !== 'undefined' && matching_media.alt !== '') {
      if (image_index > 0) {
        img_alt = `Photo ${image_index}: ${matching_media.alt}`;
      }
    }
  }
  */

  // We need to keep the placeholders until one image has been loaded to avoid layout shift)
  if (responsive) {
    return `
      <div class="product-main" data-product-main tabindex="0" role="tabpanel" data-image-pos="${image_pos}">
        <img
          class="product-main__image"
          alt="${img_alt}"
          src="${img_sized}"
          srcset="
            ${getSizedImageURL(image_src, '150x230')} 150w,
            ${getSizedImageURL(image_src, '288x440')} 288w,
            ${getSizedImageURL(image_src, '414x631')} 414w,
            ${getSizedImageURL(image_src, '550x839')} 550w,
            ${getSizedImageURL(image_src, '576x880')} 576w,
            ${getSizedImageURL(image_src, '800x1220')} 800w,
            ${getSizedImageURL(image_src, '1024x')} 1024w,
            ${getSizedImageURL(image_src, '1200x')} 1200w,
            ${getSizedImageURL(image_src, '1400x')} 1400w,
            ${getSizedImageURL(image_src, '1600x')} 1600w
          "
          sizes="(max-width: 768px) calc(100vw - 40px), 33vw"
          fetchpriority="${(image_pos === 1 && !lazyload) ? 'high' : 'auto'}"
          loading="${(image_pos === 1 && !lazyload) ? 'eager' : 'lazy'}"
          data-original="${image_src}"
          ${zoom_html}
          ${thumb_html}
          ${zoom_in_modal}
          ${(window.theme.breakpoints.current === 'mobile') ? `onLoad="document.querySelectorAll('[data-product-mobile-images] .product-main--placeholder, [data-product-mobile-images] [data-initial-media]').forEach(el => el.remove());"` : ''}
          width="${intrinsicWidth}"
          height="${intrinsicHeight}"
        />
        ${generateMainInfoElement(image_pos)}
      </div>`;
  } else {
    // Do not use loading="lazy", it doesn't work well with some mobile instances. And it's not needed since the image is within the fold
    return `
    <div class="product-main" data-product-main tabindex="0" role="tabpanel">
      <img class="product-main__image" ${src_html} ${zoom_html} ${zoom_in_modal} alt="${img_alt}" tabindex="-1" fetchpriority="${(image_pos === 1) ? 'high' : 'auto'}" width="${intrinsicWidth}" height="${intrinsicHeight}" />
    </div>`;
  }
};

const getFirstImageIndexFromSelectedColor = (selected_color) => {
  // Get array of featured_image from variants of selected color
  let featured_images = getVariantsByColor(selected_color).map(variant => variant.featured_image);

  // Remove false, null, 0, "", undefined, and NaN
  featured_images = featured_images.filter(img => !!img && img.src);

  // No assigned image to the variants (shouldn't be happening!)
  if (featured_images.length === 0) {
    featured_images.push({ src: getProductJson().featured_image });
  }

  // Cached data has https but not the storefront API data
  return getProductJson().images.findIndex(obj =>
    `https:${obj}` === featured_images[0].src || obj === featured_images[0].src
  );
};

const getLastImageIndexFromSelectedColor = (selected_color, all_images) => {
  // Find next color
  const colorSwatches = document.querySelectorAll('[data-product-option-color].color-swatch');
  const activeSwatch = document.querySelector('[data-product-option-color].color-swatch.active');
  const next_color_index = activeSwatch ? Array.from(colorSwatches).indexOf(activeSwatch) + 1 : 1;
  let next_color_first_image_index = null;

  if (next_color_index > colorSwatches.length - 1) {
    next_color_first_image_index = all_images.length;
  } else {
    const next_color = colorSwatches[next_color_index].getAttribute('data-color-value');
    next_color_first_image_index = getFirstImageIndexFromSelectedColor(next_color);
    // console.log('next_color_index', next_color_index, next_color);
  }

  return next_color_first_image_index - 1;
};

// Find out if the video is the 1st file after the 1st image (1st video is the pdp video, 2nd is the plp video)
const getProductVideo = (variant_images, video_resolution = 1080) => {
  const all_videos = getProductJson().media.filter(media => media.media_type === 'video');
  if (variant_images.length === 0 || all_videos.length === 0) {
    return null;
  }

  const first_video_index = variant_images[0].position + 1;
  const pdp_video = all_videos.find((video) => {
    return video.position === first_video_index;
  });
  console.log('pdp_video', pdp_video);

  if (typeof pdp_video !== 'undefined') {
    let video_item = pdp_video.sources.find((source) => source.format === 'mp4' && source.height === video_resolution);
    // If no match format, return the first one
    if (!video_item) {
      video_item = pdp_video.sources[0];
    }

    if (video_item) {
      return {
        src: video_item.url,
        poster: pdp_video.preview_image.src,
        alt: pdp_video.alt || '',
        type: video_item.format,
        mime_type: video_item.mime_type || 'video/mp4',
      };
    }
  }

  return null;
};

const updateDesktopProductV3 = (variant_images, product_video, product_video_mobile) => {
  const product_thumbs = document.querySelector('[data-product-thumbs]');
  const product_full = document.querySelector('[data-product-full]');
  const product_title = document.querySelector('.product-details__title');
  const title_text = product_title ? product_title.textContent : '';

  if (variant_images.length === 0 && product_video === null) {
    // No images or video to display
    if (product_full) {
      product_full.innerHTML = '';
    }

    if (product_thumbs) {
      product_thumbs.innerHTML = '';
    }

    return;
  }

  let first_image = '';
  let thumb_images = '';
  const max_thumbs = 7;
  const thumbs_urls = [];
  const full_urls = [];
  const zoom_urls = [];
  const video_urls = [];
  const alt_images = [];
  const image_widths = [];
  const image_heights = [];
  let mobile_images_html = '';
  const current_main_desktop_image = document.querySelector('[data-product-main] img');
  const current_main_desktop_image_src = current_main_desktop_image ? current_main_desktop_image.dataset.original : '';

  let i = 1;
  variant_images.forEach((image) => {
    // We load the 1st image with Liquid to avoid layout shift and increase LCP; only replace the first image if different than the one already loaded
    // if (i === 1) {
    //   console.log('1st image', image.src, ' - ' , current_main_desktop_image_src, (image.src === current_main_desktop_image_src));
    // }
    if (i === 1 && image.src !== current_main_desktop_image_src) {
      first_image = generateImageElement(image, '600x', '4000x', false, true, true, true, i);
    }

    // Add the video at the 2nd position if available
    if (product_video && i === 2) {
      const alt_text = (product_video.alt === null || product_video.alt === '') ? title_text : product_video.alt;
      thumbs_urls.push(getSizedImageURL(product_video.poster, '220x'));
      full_urls.push(product_video.poster);
      // full_urls.push(getSizedImageURL(product_video.poster, '1200x'));
      zoom_urls.push('video'); // No zoom for video
      alt_images.push(alt_text);
      video_urls.push(product_video.src);
      image_widths.push('');
      image_heights.push('');

      if (product_video_mobile) {
        mobile_images_html += `
        <div class="product-main has-video" data-product-main tabindex="0" role="tabpanel">
          <div class="product-main__video">
            <video playsinline disablepictureinpicture muted loop preload="auto" class="product-main__video-player" tabindex="0" aria-label="Product video - ${alt_text}" aria-description="This video only visualizes the product and does not provide additional information" poster="${getSizedImageURL(product_video_mobile.poster, '1200x')}">
              <source src="${product_video_mobile.src}" type="video/mp4">
              Your browser does not support the video tag.
            </video>
  
            <button type="button" class="product-main__controls" data-product-video-control></button>
         </div>
        </div>
       `;
      }

      i++;
    }

    // thumbs_urls.push(getSizedImageURL(image.src, '220x'));
    thumbs_urls.push(image.src);
    full_urls.push(image.src);
    // full_urls.push(getSizedImageURL(image.src, '1200x'));
    zoom_urls.push(getSizedImageURL(image.src, '4000x'));
    alt_images.push((image.alt === null || image.alt === '') ? title_text : image.alt);
    video_urls.push(''); // No video for image
    image_widths.push(Number(image?.width) > 0 ? Number(image.width) : DEFAULT_IMAGE_WIDTH);
    image_heights.push(Number(image?.height) > 0 ? Number(image.height) : DEFAULT_IMAGE_HEIGHT);

    mobile_images_html += generateImageElement(image, '600x', '4000x', false, true, true, true, i);
    i++;
  });

  // Add the 1st image (it can't be a video)
  if (product_full && first_image !== '') {
    product_full.innerHTML = first_image;
  }

  // Generate the thumbnails for the desktop version
  thumb_images = thumbs_urls.map((thumb, index) => {
    let img_html = '';
    if (video_urls[index] === '') {
      img_html = `
        <img
          class="product-images__thumb-image"
          src="${getSizedImageURL(thumb, '204x')}"
          alt="Thumbnail #${index + 1} showing: ${alt_images[index]}"
          srcset="
            ${getSizedImageURL(thumb, '110x')} 550w,
            ${getSizedImageURL(thumb, '204x')} 800w,
            ${getSizedImageURL(thumb, '204x')} 1280w,
          "
          sizes="(min-width: 769px) 204x"
          fetchpriority="auto"
          loading="lazy"
          width="104"
        />`;
    } else {
      img_html = `
        <img
          class="product-images__thumb-image"
          src="${thumb}"
          alt="Thumbnail #${index + 1} showing: ${alt_images[index]}"
          fetchpriority="auto"
          loading="lazy"
          width="104"
        />`;
    }

    return `
      <div
        class="product-images__thumb${(zoom_urls[index] === 'video') ? ' product-images__thumb--video' : ''}"
        id="control-slide-${index + 1}"
        role="tab"
        aria-selected="${(index === 0)}"
        type="button"
        tabindex="${(index === 0) ? '0' : '-1'}"
        data-product-thumb
        ${(video_urls[index] !== '') ? `data-product-video="${video_urls[index]}"` : ''}
        data-product-full-url="${full_urls[index]}"
        data-product-zoom-url="${zoom_urls[index]}"
        data-product-width="${image_widths[index]}"
        data-product-height="${image_heights[index]}">
        ${img_html}
      </div>
    `;
  }).slice(0, max_thumbs).join('');

  // Add the thumbnails
  if (product_thumbs) {
    product_thumbs.innerHTML = thumb_images;
  }

  // [ADA] Keyboard navigation for product image thumbs (tabs)
  const thumbs = Array.from(document.querySelectorAll('.product-images__thumb'));
  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('keydown', (e) => {
      let newIdx = idx;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        newIdx = (idx + 1) % thumbs.length;
        e.preventDefault();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        newIdx = (idx - 1 + thumbs.length) % thumbs.length;
        e.preventDefault();
      } else if (e.key === 'Home') {
        newIdx = 0;
        e.preventDefault();
      } else if (e.key === 'End') {
        newIdx = thumbs.length - 1;
        e.preventDefault();
      } else if (e.key === 'Enter' || e.key === ' ') {
        thumb.click();
        e.preventDefault();
        return;
      } else {
        return;
      }

      // Update tabindex and aria-selected for all thumbs
      thumbs.forEach((t, i) => {
        t.setAttribute('tabindex', i === newIdx ? '0' : '-1');
        t.setAttribute('aria-selected', i === newIdx ? 'true' : 'false');
      });

      // Move focus
      thumbs[newIdx].focus();
      // Optionally, trigger click to change image on focus move:
      // thumbs[newIdx].click();
    });
  });

  return mobile_images_html;
};

const updateDesktopProductV4 = (variant_images, product_video, product_video_mobile) => {
  const product_full = document.querySelector('[data-product-full]');
  const product_title = document.querySelector('.product-details__title');
  const title_text = product_title ? product_title.textContent : '';

  const full_urls = [];
  const zoom_urls = [];
  const video_urls = [];
  const alt_images = [];
  let desktop_images_html = '';
  let mobile_images_html = '';

  if (variant_images.length === 0 && product_video === null) {
    // No images or video to display
    if (product_full) {
      product_full.parentElement.innerHTML = '';
    }

    return;
  }

  // The desktop gallery is hidden on mobile: lazy images in a hidden container are not downloaded (they would compete with the mobile LCP image)
  const lazy_desktop_images = window.theme.breakpoints.current === 'mobile';

  // Keep the Liquid rendered 1st image when it already matches the selected color, to avoid downloading the LCP image again
  const initial_image = product_full.querySelector('li:first-child img.product-main__image[data-media-id]');
  const keep_initial_image = initial_image && initial_image.dataset.mediaId === String(variant_images[0]?.id);

  let i = 1;
  variant_images.forEach((image) => {
    full_urls.push(image.src);
    zoom_urls.push(getSizedImageURL(image.src, '4000x'));
    alt_images.push((image.alt === null || image.alt === '') ? title_text : image.alt);
    video_urls.push(''); // No video for image

    if (i > 1 || !keep_initial_image) {
      desktop_images_html += `<li ref="media[]" class="product-media-container">${generateImageElement(image, '600x', '4000x', lazy_desktop_images, true, true, true, i)}</li>`;
    }
    mobile_images_html += generateImageElement(image, '600x', '4000x', false, true, true, true, i);
    i++;
  });

  if (keep_initial_image) {
    // Same attributes as generateImageElement() for the zoom modal
    const image = variant_images[0];
    initial_image.removeAttribute('data-media-id'); // Only kept on first load
    initial_image.alt = alt_images[0];
    initial_image.dataset.original = image.src;
    initial_image.dataset.thumb = getSizedImageURL(image.src, '180x');
    initial_image.setAttribute('data-modal', '#zoom-modal');

    const container = initial_image.closest('.product-main');
    container.setAttribute('data-product-main', '');
    container.setAttribute('role', 'tabpanel');
    container.tabIndex = 0;
    container.dataset.imagePos = 1;
    container.insertAdjacentHTML('beforeend', generateMainInfoElement(1));

    // Replace the placeholders after the 1st image
    product_full.querySelectorAll('li:not(:first-child)').forEach(el => el.remove());
    product_full.insertAdjacentHTML('beforeend', desktop_images_html);
  } else {
    product_full.innerHTML = desktop_images_html;
  }

  return mobile_images_html;
};

// Extract the variant images/video only
export default () => {
  const product_overview_section = document.querySelector('[data-product-overview]');
  const pdp_version = (document.querySelector('.template-product-new')) ? 4 : 3;

  if (!product_overview_section || !document.querySelector('[data-product-json]') || (!document.querySelector('[data-option-color]') && !document.querySelector('[data-single-option-selector]'))) {
    return false;
  }

  // Get all images from the product
  const all_images = getProductJson().media.filter(media => media.media_type === 'image');
  // const all_images = getProductJson().images;
  const color_option = document.querySelector('[data-option-color]');
  const color_index = color_option ? parseInt(color_option.getAttribute('data-option-index'), 10) : 0;
  const selected_variant = getSelectedVariantByIdJson();
  let first_image_index = 0;
  let last_image_index = all_images.length - 1;

  if (document.querySelectorAll('[data-single-option-selector]').length) {
    // find 1st and last image
  } else {
    const selected_color = selected_variant.options[color_index];
    first_image_index = getFirstImageIndexFromSelectedColor(selected_color);
    last_image_index = getLastImageIndexFromSelectedColor(selected_color, all_images);
  }

  // We assigned the main featured image in getFirstImageIndexFromSelectedColor()
  if (first_image_index === -1) {
    first_image_index = 0;
  }

  if (last_image_index < first_image_index) {
    last_image_index = first_image_index;
  }

  const show_videos = product_overview_section.dataset.productVideos === 'true';
  const variant_images = all_images.slice(first_image_index, last_image_index + 1);
  const mobile_images_container = document.querySelector('[data-product-mobile-images]');
  const product_video = (show_videos) ? getProductVideo(variant_images, 1080) : null;
  const product_video_mobile = (show_videos) ? getProductVideo(variant_images, 720) : null;
  let mobile_images_html = '';

  if (pdp_version === 4) {
    mobile_images_html = updateDesktopProductV4(variant_images, product_video, product_video_mobile);
  } else {
    mobile_images_html = updateDesktopProductV3(variant_images, product_video, product_video_mobile);
  }

  // Mobile images / video
  if (mobile_images_container) {
    mobile_images_container.classList.remove('single-image');

    // Keep the Liquid rendered media when it already matches the selected color, to avoid downloading the images again (blinking)
    const initial_media = Array.from(mobile_images_container.querySelectorAll('[data-initial-media]'));
    const keep_initial_media = initial_media.length > 0 &&
      initial_media.length === variant_images.length &&
      initial_media.every((el, index) => el.dataset.mediaId === String(variant_images[index].id));

    if (keep_initial_media) {
      initial_media.forEach((el, index) => {
        el.removeAttribute('data-initial-media');
        el.dataset.imagePos = index + 1;
        el.insertAdjacentHTML('beforeend', generateMainInfoElement(index + 1));
      });
    } else {
      // On mobile, the initial media is removed once one of the new images has been loaded (onLoad in generateImageElement())
      if (window.theme.breakpoints.current !== 'mobile') {
        initial_media.forEach(el => el.remove());
      }

      // mobile_images_container.innerHTML = mobile_images_html;
      // Append the mobile images HTML (we need to keep the placeholders/initial images until one of the images has been loaded to avoid layout shift)
      mobile_images_container.insertAdjacentHTML('beforeend', mobile_images_html);
    }

    if (product_video_mobile) {
      const mobile_video_status = `<div aria-live="polite" aria-atomic="true" class="sr-only" data-product-media-status>Main product video is now playing</div>`;
      mobile_images_container.innerHTML += mobile_video_status;

      window.setTimeout(() => {
        document.querySelectorAll('[data-product-mobile-images] [data-product-main].has-video').forEach((video_container) => {
          const video = video_container.querySelector('video');
          if (!video) return;

          // IntersectionObserver callback
          const handleIntersection = (entries) => {
            entries.forEach(entry => {
              const status_el = mobile_images_container.querySelector('[data-product-media-status]');

              if (entry.isIntersecting) {
                video.play();
                video_container.classList.add('has-video--playing');

                if (status_el) {
                  mobile_images_container.querySelector('[data-product-media-status]').innerText = 'Main product video is now playing';
                }
              } else {
                video.pause();
                video_container.classList.remove('has-video--playing');

                if (status_el) {
                  mobile_images_container.querySelector('[data-product-media-status]').innerText = 'Main product video is paused';
                }
              }
            });
          };

          // Create observer
          const observer = new IntersectionObserver(handleIntersection, {
            threshold: 0.5 // Play/pause when at least 50% visible
          });
          observer.observe(video_container);

          const video_controls = video_container.querySelector('[data-product-video-control]');
          video_controls.addEventListener('touchend', (event) => {
            if (video.paused) {
              video.play();
              event.target.closest('.product-main').classList.add('has-video--playing');
              mobile_images_container.querySelector('[data-product-media-status]').innerText = 'Main product video is now playing';
            } else {
              video.pause();
              event.target.closest('.product-main').classList.remove('has-video--playing');
              mobile_images_container.querySelector('[data-product-media-status]').innerText = 'Main product video is paused';
            }
          });
        });
      }, 10);
    }

    // Single image full width on mobile
    if (variant_images.length <= 1) {
      mobile_images_container.classList.add('single-image');
    }
  }
};
